import {currentPrize, totalPrizes} from "../helpers/config";


export const Header = () => {
    return (
        <header>
            <div className="header-wrapper">
                <p>Premii totale de <strong>{totalPrizes}</strong></p>
                <p>Premii la cursele curente de <strong>{currentPrize}</strong></p>
            </div>
        </header>
    )
}